"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _error = require("../error");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var userFocus = {}; // track active job per user

var interactions = {};
/**
 * Service for backgrounding for interactive commands
 */

var interaction = function interaction() {
  return function (_ref) {
    var configService = _ref.configService,
        environmentService = _ref.environmentService,
        jobService = _ref.jobService,
        listenerService = _ref.listenerService,
        messengerService = _ref.messengerService;
    var prompt = configService.ps2;
    return {
      createInteractionChannel: function createInteractionChannel() {
        var _arguments = arguments;
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var userIds, pid, _yield$jobService$fin, id, context, userId, members, channelListener, userGate, delegateMessage, getInteractionPipe;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  userIds = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                  pid = environmentService.get('!');

                  if (!interactions[pid]) {
                    _context2.next = 4;
                    break;
                  }

                  throw new Error("Interaction already running for pid ".concat(pid));

                case 4:
                  _context2.next = 6;
                  return jobService.findOne({
                    'command.pid': pid
                  });

                case 6:
                  _yield$jobService$fin = _context2.sent;
                  id = _yield$jobService$fin.id;
                  context = _yield$jobService$fin.context;
                  userId = _yield$jobService$fin.userId;
                  members = [userId].concat(_toConsumableArray(userIds));
                  channelListener = listenerService.listen(new RegExp("^".concat((0, _lodash.escapeRegExp)(prompt)))).pipe(function (_ref2) {
                    var message = _ref2.message;
                    return _objectSpread({}, message, {
                      text: message.text.substring(prompt.length)
                    });
                  }); // only deliver message if the sender in in the included users

                  userGate = function userGate(message) {
                    return members.includes(message.user.id) ? message : null;
                  }; // only activate pipe for the active interaction for a user


                  delegateMessage = function delegateMessage(message) {
                    return userFocus[message.user.id] === pid ? message : null;
                  };

                  getInteractionPipe = function getInteractionPipe() {
                    return channelListener.pipe(userGate).pipe(delegateMessage);
                  };

                  interactions[pid] = members;
                  jobService.subscribe(id, function (job) {
                    if (!job.status !== jobService.status.RUNNING) {
                      delete interactions[job.command.pid];
                    }
                  });
                  return _context2.abrupt("return", {
                    prompt: function prompt(string) {
                      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                // get result from first user who answers
                                members.forEach(function (id) {
                                  return userFocus[id] = pid;
                                });
                                return _context.abrupt("return", new Promise(function (resolve) {
                                  messengerService.respond(context, string);
                                  var stream = getInteractionPipe().pipe(function (message) {
                                    stream.end();
                                    resolve(message);
                                  });
                                }));

                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }))();
                    },
                    observe: function observe() {
                      members.forEach(function (id) {
                        return userFocus[id] = pid;
                      });
                      return getInteractionPipe();
                    },
                    send: function send(message) {
                      messengerService.respond(context, message);
                    }
                  });

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },
      foreground: function foreground(userId, jobId) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var job;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return jobService.findOne({
                    id: jobId
                  });

                case 2:
                  job = _context3.sent;

                  if (!(job.status !== jobService.status.RUNNING)) {
                    _context3.next = 5;
                    break;
                  }

                  throw new _error.StateError('Cannot foreground a job which is not running');

                case 5:
                  if (interactions[job.command.pid].includes(userId)) {
                    _context3.next = 7;
                    break;
                  }

                  throw new _error.PermissionError('Cannot foreground a job which this user does not belong to');

                case 7:
                  userFocus[userId] = job.command.pid;

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    };
  };
};

var _default = interaction;
exports.default = _default;